'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createStore = createStore;

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createStore(reducers, rawHistory) {
  var middlewares = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
  var enhancers = arguments.length <= 3 || arguments[3] === undefined ? [] : arguments[3];

  var createStoreWithMiddleware = _redux.compose.apply(undefined, [_redux.applyMiddleware.apply(undefined, [_reduxThunk2.default].concat(_toConsumableArray(middlewares)))].concat(_toConsumableArray(enhancers)))(_redux.createStore);

  var reducer = (0, _redux.combineReducers)(_extends({}, reducers, {
    routing: _reactRouterRedux.routerReducer
  }));
  var store = createStoreWithMiddleware(reducer);
  var history = (0, _reactRouterRedux.syncHistoryWithStore)(rawHistory, store);

  return { history: history, store: store };
}


//////////////////
// WEBPACK FOOTER
// ./~/@dr-kobros/react-broilerplate/lib/redux.js
// module id = 681
// module chunks = 0